import React from 'react';
import { List } from '../../../components';
import { ListContainer } from '../../../containers';
import { useRefreshPage } from '../../../hooks/useRefreshPage';
import LocationSetupListItem from './LocationSetupListItem';

const LocationSetupList = ({
	items,
	refetch,
	customProps,
	customControls,
}) => {
	const [refreshPage, isRefreshing] = useRefreshPage(refetch);

	return (
		<List
			items={items}
			listItemComponent={LocationSetupListItem}
			onRefresh={refreshPage}
			isRefreshing={isRefreshing}
			emptyListMessage="No location setups found"
			autoScrollTop={true}
			showControls={true}
			removeTopMargin={true}
			customProps={customProps}
			customControls={customControls}
		/>
	);
};

export default ListContainer(LocationSetupList);
